import GeoTrace from '../../network/assets/js/geo-script.js';

/**
 * Class MultiCurrency
 */
export default class MultiCurrency {

	/**
	 * setCurrency
	 *
	 * @returns void
	 */
	async run( data ) {

		const userCurrency = await this.getUserCurrency( data );

		// Setting Prices
		document.querySelectorAll( '[' + data.priceDataSelector + ']' ).forEach( element => {

			const elementData = JSON.parse( element.getAttribute( data.priceDataSelector ) );
			const product_id = elementData['product_id'];
			const variation_id = elementData['variation_id'];
			const attribute = elementData['attribute'];
			const span = document.createElement('span');
			const price = document.createTextNode( data['products'][ product_id ]['children'][ variation_id ][ attribute ][ userCurrency ] );
			span.setAttribute( 'price-attribute', attribute );
			span.setAttribute( data.priceDataSelector, element.getAttribute( data.priceDataSelector ) );
			span.appendChild( price );
			element.parentElement.replaceChild( span, element );

		} );

		// Setting Currency Symbols
		document.querySelectorAll( '.elementor-currency-symbol' ).forEach( element => {

			const span = document.createElement( 'span' );
			const currencySymbol = document.createTextNode( this.decodeEntities( data['currencySymbols'][ userCurrency ] ) );
			span.appendChild( currencySymbol );
			span.classList.add( 'elementor-currency-symbol' );
			span.setAttribute( 'data-multi-currency-version', data['apiVersion'] );
			element.parentElement.replaceChild( span, element );

		} );

		// Adding currency parameter to products links
		document.querySelectorAll( 'a[href]' ).forEach( element => {
			let href = element.getAttribute( 'href' );
			href = this.addCurrencyToProductLink( href, userCurrency );
			element.setAttribute( 'href', href );
		} );

		// Set currency cookie
		this.setSessionCookie( 'woocommerce_multicurrency_forced_currency', userCurrency );

	}

	async getLocationCode() {
		return await new GeoTrace().getLocationCode();
	}

	addCurrencyToProductLink( href, userCurrency ) {
		const splitHref = href.split( '?' );
		const params = new URLSearchParams( splitHref[1] );

		if ( ! params.has( 'currency' ) ) {
			return href
		}

		params.set( 'currency', userCurrency );
		return splitHref[0] + '?' + params.toString();
	}

	/**
	 * getUserCurrency
	 *
	 * @param data
	 *
	 * @return Promise<string>
	 */
	async getUserCurrency( data ) {
		const locationCode = await this.getLocationCode();

		const currenciesCountries = data['currenciesCountries'];
		if ( ! currenciesCountries[ locationCode ] || this.shouldDefaultCurrencyBeUsed( locationCode, data ) ) {
			return currenciesCountries['default']['currency'];
		}
		return currenciesCountries[locationCode]['currency'];
	}

	getCookie( name ) {
		const matches = document.cookie.match( new RegExp(
			"(?:^|; )" + name.replace( /([.$?*|{}()\[\]\\\/+^])/g, '\\$1' ) + "=([^;]*)"
		) );
		return matches ? decodeURIComponent( matches[ 1 ] ) : undefined;
	}

	/**
	 * Create a new cookie for the site.
	 * @param name The key of the cookie
	 * @param value The value of the cookie
	 */
	setSessionCookie( name, value ) {
		document.cookie = name + '=' + value + '; expires=0' + '; path=/';
	}

	decodeEntities( encodedString ) {
		const textArea = document.createElement('textarea');
		textArea.innerHTML = encodedString;
		return textArea.value;
	}

	// Euro A/B test logic
	// TODO 24/07/2023 : Remove in HTS-636

	shouldDefaultCurrencyBeUsed( locationCode, data ) {
		this.testGroup = this.testGroup ?? this.getCookieTestGroup( data );

		if ( this.testGroup ) {
			return this.testGroup !== data['euroTestValue'];
		}

		// Users that are in the tested countries and don`t have a cookie should get default currency.
		return this.getTestedCountries( data ).includes( locationCode );
	}

	async maybeAttachEuroTestListener(data) {
		const locationCode = await this.getLocationCode();

		if ( ! this.getTestedCountries( data ).includes( locationCode ) ) {
			return;
		}

		document.addEventListener( 'EuroTestCookieSet', ( e ) => {
			this.runEuroTest( data, e.detail );
		} );
	}

	runEuroTest( data, testGroup ) {
		this.testGroup = testGroup;

		this.run( data );
	}

	getCookieTestGroup( data ) {
		const cookie = this.getCookie( '_gaexp' );

		// Cookie structure : FIRST_TEST_ID.000.{0/1}!SECOND_TEST_ID.000.{0/1}
		// Last number indicates A or B
		// Third part for the end is the test id
		if ( cookie ) {
			const tests = cookie.split( '!' );
			const test = tests.find( test => {
				const splitTest = test.split( '.' );
				return splitTest[ splitTest.length - 3 ] === data.euroTestId;
			} );

			if ( test && '' !== test ) {
				const splitTest = test.split( '.' );
				return splitTest[ splitTest.length - 1 ];
			}
		}
	}

	/**
	 * Get array of tested countries codes.
	 *
	 * @param data
	 * @return {[]}
	 */
	getTestedCountries( data ) {
		return data[ 'euroTestedCountries' ].split( ',' ).map( country => country.trim() );
	}
	// TODO 24/07/2023 : Remove in HTS-636 ^^^^
	// End Euro A/B test logic
}

if ( window.multiCurrencyData ) {
	new MultiCurrency().run( window.multiCurrencyData );
}
if ( window.multiCurrencyDataV2 ) {
	new MultiCurrency().run( window.multiCurrencyDataV2 );
}
if ( window.multiCurrencyDataV3 ) {
	const multiCurrency = new MultiCurrency();
	multiCurrency.run( window.multiCurrencyDataV3 );
	multiCurrency.maybeAttachEuroTestListener( window.multiCurrencyDataV3 );
}
